import React from 'react';
import { Popover, Box, IconButton, Typography, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ContextualPopover = ({
  open,
  anchorEl,
  onDismiss,
  message,
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' },
  transformOrigin = { vertical: 'top', horizontal: 'center' },
}) => {
  const theme = useTheme();

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onDismiss}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      disableRestoreFocus
      sx={{
        '& .MuiPopover-paper': {
          maxWidth: 320,
          borderRadius: 2,
          border: `2px solid ${(theme.vars || theme).palette.primary.main}`,
          backgroundColor: (theme.vars || theme).palette.background.paper,
          boxShadow: theme.shadows[8],
        },
      }}
    >
      <Box
        sx={{
          p: 2,
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            flex: 1,
            color: (theme.vars || theme).palette.text.primary,
            lineHeight: 1.5,
          }}
        >
          {message}
        </Typography>
        <IconButton
          size="small"
          onClick={onDismiss}
          sx={{
            ml: 'auto',
            color: (theme.vars || theme).palette.text.secondary,
            '&:hover': {
              color: (theme.vars || theme).palette.text.primary,
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </Popover>
  );
};

export default ContextualPopover;
